module.exports = __webpack_public_path__ + "img/nfc-icon.cc02bc44.svg";